import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { teamUsers } from "../../../../assets/utils/data/table/employees";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { tableColumnType, TableTypeEnum } from "../../../../assets/utils/enums/table";
import { BodyDiv } from "../../../../components/components-style";
import { MediumText, NotificationText, SubTitle } from "../../../../components/typography";
import { Button } from "../../../../components/ui/button";
import DataTable from "../../../../components/ui/table";
import plusIcon from "../../../../assets/images/icons/dark/plus-icon.svg";
import linkLightIcon from "../../../../assets/images/icons/light/link-icon.svg";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function ViewTeam() {
    const navigate = useNavigate();
    return (
        <FixedBodyDiv className={`w-60 ${SETTINGS_BODY_DIV} `} $isPadding={true}>
            <TitleSpan>
                <SubTitle>Користувачі</SubTitle>
                <NotificationText>Управління учасниками команди в робочому просторі</NotificationText>
            </TitleSpan>
            <span className="w-100 d-flex align-items-center justify-content-between">
                <Button
                    bgcolor={COLORS["light-gray"]}
                    txtcolor={COLORS.secondary1}
                    brcolor={COLORS.gray}
                    width="49%"
                    type="large"
                    brradius="24px"
                    className="gap-2"
                    onClick={() => {
                        navigate("/settings/team/add");
                    }}
                >
                    <img src={plusIcon} alt="plus-icon" />
                    <NotificationText>Додати користувача</NotificationText>
                </Button>
                <Button
                    bgcolor={COLORS.blue}
                    txtcolor={COLORS["light-gray"]}
                    brcolor={COLORS.blue}
                    width="49%"
                    type="large"
                    brradius="24px"
                    className="gap-2"
                    onClick={() => {
                        navigate("/settings/team/send-invite");
                    }}
                >
                    <img src={linkLightIcon} alt="link-light-icon" />
                    <NotificationText>Запросити за посиланням</NotificationText>
                </Button>
            </span>
            <span className="w-100 pt-3">
                <DataTable
                    data={teamUsers}
                    table={tableColumnType[TableTypeEnum.TEAM_USERS]}
                    isPage={TableTypeEnum.TEAM_USERS}
                />
            </span>
        </FixedBodyDiv>
    )
}

export const FixedBodyDiv = styled(BodyDiv)`
    width: 60% !important;
`

export const TitleSpan = styled.span`
width: 100%;
display: flex;
flex-direction: column;
align-items: start;
gap: 2px;
padding-bottom: 16px;
    ${SubTitle}, ${MediumText} {
        color: ${COLORS.secondary1};
    }
    ${NotificationText} {
        color: ${COLORS["bg-text-color"]};
    }

    img {
        width: 24px;
        height: 24px;
    }

    hr {
  border: none;
  height: 1px;
  width: 32px;
  background: ${COLORS.secondary1};
  opacity: 1;
  border-radius: 2px;
  /* margin: 16px 0; */
}
    
`